

export default {
  listMerchants(data) {
    return http.get({
      url: '/la/admin/merchant/store',
      data
    });
  },
  createMerchant(data) {
    return http.post({
      url: '/la/admin/merchant/create',
      data,
      dataType: 'form'
    });
  },
  removeMerchant(data) {
    return http.post({
      url: '/la/admin/merchant/detach',
      data,
      dataType: 'form'
    });
  },
  getCoinList(data) {
    return http.get({
      url: '/la/admin/get/c2cCoinTypeList',
      data
    });
  },
  addCoin(data) {
    return http.post({
      url: '/la/admin/add/c2cCoinType',
      data,
      dataType: 'form'
    });
  },
  deleteCoin(data) {
    return http.post({
      url: '/la/admin/delete/c2cCoinType',
      data,
      dataType: 'form'
    });
  }
};
